@use '../colors.scss' as colors;
@use '../vars.scss' as vars;

.ccv-tooltip-content {
  display: flex;
  align-items: center;
  div {
    margin-left: 0.7em;
  }
  svg {
    width: 54px;
    height: 38px;
  }
}

/* Info Tooltip */

.up-info-tooltip {
  display: inline-block;
  position: relative;
  bottom: -0.099em;
  margin-left: 0.4em;

  button {
    padding: 0;
    border: none;
    background-color: white;
  }
}

.up-info-tooltip .up-info-tooltip-text {
  display: block;
  min-width: 220px;
  border: 1px solid colors.$tooltip-border;
  background-color: #fff;
  font-size: 13px;
  font-weight: 400;
  color: colors.$tooltip-text;
  text-align: center;
  border-radius: 5px;
  padding: 6px 10px;
  position: absolute;
  z-index: 1;
  bottom: 130%;
  left: 50%;
  margin-left: -100px;
  transition: opacity 0.3s ease-out;
  box-shadow: 0 4px 7px rgba(0, 0, 0, 0.3);
}

.up-info-tooltip .up-info-tooltip-text-dynamic-arrow {
  left: 90px;
}

.up-info-tooltip .up-info-tooltip-text-dynamic-arrow::before {
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 7px solid colors.$tooltip-border;
  bottom: -7px;
  left: inherit;
  margin-left: inherit;
  content: '';
  width: 0;
  height: 0;
  position: absolute;
  box-sizing: border-box;
}

.up-info-tooltip .up-info-tooltip-text-dynamic-arrow::after {
  content: '';
  position: absolute;
  top: 100%;
  left: inherit;
  margin-left: inherit;
  border-top-color: #fff;
  border-top-style: solid;
  border-top-width: 6px;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  width: 0;
  height: 0;
  box-sizing: border-box;
}

.up-info-tooltip-hidden {
  visibility: hidden;
  opacity: 0;
}

.up-info-tooltip-visible {
  visibility: visible;
  opacity: 1;
}
